import React from 'react';
import PropTypes from 'prop-types';
import './ZoomTools.css';

const ZoomTools = props => {
  const { zoomIn, zoomOut } = props;
  return (
    <div className='tools'>
      <button type='button' className='zoomIn' onClick={zoomIn}>
        +
      </button>
      <button type='button' className='zoomOut' onClick={zoomOut}>
        -
      </button>
    </div>
  );
};
export default ZoomTools;

ZoomTools.defaultProps = {
  zoomIn: null,
  zoomOut: null,
};

ZoomTools.propTypes = {
  zoomIn: PropTypes.func,
  zoomOut: PropTypes.func,
};
